export enum currencyValue {
  DEFAULT = 1000,
  CRUZEIRO_REAL = 2750,
  REAL = 1,
}
export enum currencyDate {
  _1994_07_01_ = '1994-07-01T00:00:00.000Z',
  _1993_08_01_ = '1993-08-01T00:00:00.000Z',
  _1989_01_01_ = '1989-01-01T00:00:00.000Z',
  _1986_03_01_ = '1986-03-01T00:00:00.000Z',
  _1967_02_01_ = '1967-02-01T00:00:00.000Z',
  _1942_11_01_ = '1942-11-01T00:00:00.000Z',
}
export enum currencySymbol {
  _1942_10_01_ = 'R$,Réis,Réis',
  _1967_02_01_ = 'Cr$,Cruzeiro,Cruzeiros',
  _1970_05_01_ = 'NCr$,Cruzeiro Novo,Cruzeiros Novos',
  _1986_02_01_ = _1967_02_01_,
  _1989_01_01_ = 'Cz$,Cruzado,Cruzados',
  _1990_03_01_ = 'NCz$,Cruzado Novo,Cruzados Novos',
  _1993_08_01_ = _1967_02_01_,
  _1994_07_01_ = 'CR$,Cruzeiro Real,Cruzeiros Reais',
  _1994_08_01_ = 'R$,Real,Reais',
}
